import { Box, SxProps } from '@mui/material';
import React from 'react';
import AppIcon from '../AppIcon/AppIcon';
import { AppIconType } from '../AppIcon/const';
import Tooltip from '../Tooltip/Tooltip';

interface AppIconLabelProps {
  icon: AppIconType;
  tooltipTitle?: string;
  sxIcon?: SxProps;
  sxBox?: SxProps;
}

const AppIconLabel: React.FC<AppIconLabelProps> = ({ icon, tooltipTitle, sxIcon, sxBox }) => {
  return (
    <Tooltip title={tooltipTitle}>
      <Box
        id="app-icon-span-id"
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginRight: '15px',
          ...sxBox,
        }}
      >
        <AppIcon sx={sxIcon} icon={icon} style={{ fontSize: '22px', color: 'var(--mui-palette-common-inputIcons)' }} />
      </Box>
    </Tooltip>
  );
};

export default AppIconLabel;
